import { memo, PropsWithChildren } from "react";

/**
 * Empty component to render children within a Fragment. Useful for rendering
 * either a desired component or children only.
 */
const PlainWrapper = ({ children }: PropsWithChildren) => <>{children}</>;

export default memo(PlainWrapper);
